import { Event, LinkPreview, Post } from 'model';
import { SetValuesFunction } from '../hooks/useFormValues';
import { IconButton } from './IconButton';
import styles from './LinkPreviewComponent.module.css';
import { IconTrash } from './QuirkIcons';

type LinkPreviewProps<T extends Post> = {
	linkPreview?: LinkPreview | null;
	setValues?: T extends Event ? SetValuesFunction<Event> : SetValuesFunction<T>;
};

function isYouTubeVideo(url: URL): boolean {
	return (url.hostname === 'www.youtube.com' || url.hostname === 'youtube.com') && url.pathname.includes('/watch');
}

export const LinkPreviewComponent = <T extends Post>({ linkPreview, setValues }: LinkPreviewProps<T>) => {
	if (!linkPreview) return null;
	let url: URL;
	try {
		url = new URL(linkPreview.url);
	} catch (e) {
		return null;
	}
	const origin = url.origin.replace('www.', '').replace('https://', '').replace('http://', '').toUpperCase();
	const isYouTube = isYouTubeVideo(url);
	const onDelete = () => {
		setValues && setValues({ linkPreview: null });
	};
	return (
		<>
			{setValues && <IconButton icon={<IconTrash />} label="Remove Preview" onClick={onDelete} />}
			<div className={styles.container}>
				{isYouTube ? (
					<div className={styles.youTube}>
						<iframe
							src={`https://www.youtube.com/embed/${url.searchParams.get('v')}`}
							title="YouTube Video Player"
							frameBorder={0}
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						></iframe>
					</div>
				) : (
					<a className={styles.anchor} href={linkPreview.url}>
						{linkPreview.image && (
							<img className={styles.image} src={linkPreview.image} alt={linkPreview.title} />
						)}
						<div className={styles.text}>
							<div className={styles.siteName}>{origin}</div>
							<div>{linkPreview.title}</div>

							<div className={styles.description}>{linkPreview.description}</div>
						</div>
					</a>
				)}
			</div>
		</>
	);
};
